package com.patronat.top.features.dashboard.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.ReviewResponse
import com.patronat.top.features.dashboard.domain.repository.ReviewModerationRepository
import com.patronat.top.features.dashboard.domain.usecase.command.ModerateReviewCommand

class ModerateReviewUseCase(
    private val repository: ReviewModerationRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ModerateReviewCommand, DomainResult<ReviewResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ModerateReviewCommand): DomainResult<ReviewResponse> {
        return repository.moderateReview(
            reviewId = command.reviewId,
            approved = command.approved
        )
    }
}
